import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "recent-bookings-card card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "p-25" }
const _hoisted_3 = { class: "d-flex flex-wrap gap-2 justify-content-between align-items-center mb-3 mb-4" }
const _hoisted_4 = { class: "d-flex align-items-center bg-gray-100 py-2 px-3 rounded-2 for-dark-digital-date" }
const _hoisted_5 = { class: "calendar" }
const _hoisted_6 = { class: "header d-flex align-items-center justify-content-between" }
const _hoisted_7 = { class: "fw-medium text-black" }
const _hoisted_8 = { class: "weekdays text-center" }
const _hoisted_9 = { class: "days text-center" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  key: 1,
  class: "blank-day"
}
const _hoisted_12 = { class: "p-25 pt-0 pe-0" }
const _hoisted_13 = {
  class: "last-child-none pe-4 recent-room-bookings scrollbar",
  style: {"height":"505px"}
}
const _hoisted_14 = {
  class: "d-flex align-items-center",
  style: {"gap":"15px"}
}
const _hoisted_15 = { class: "flex-shrink-0" }
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "flex-grow-1" }
const _hoisted_18 = { class: "fs-14 fw-semibold mb-6" }
const _hoisted_19 = { class: "d-block fs-12 mb-9 text-body" }
const _hoisted_20 = {
  class: "bg-border-color-50 fs-12 fw-medium text-primary d-inline-block rounded-1",
  style: {"padding":"3px 8px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[3] || (_cache[3] = _createElementVNode("h3", { class: "fs-18 fw-bold mb-0" }, "Recent Bookings", -1)),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", null, _toDisplayString(_ctx.formattedDate), 1),
            _cache[2] || (_cache[2] = _createElementVNode("i", { class: "ri-calendar-2-line ms-2 fs-18 lh-1" }, null, -1))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.previousMonth && _ctx.previousMonth(...args))),
            class: "p-0 border-0 d-flex align-items-center justify-content-center rounded-circle transition"
          }, [...(_cache[4] || (_cache[4] = [
            _createElementVNode("i", { class: "material-symbols-outlined" }, "chevron_left", -1)
          ]))]),
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.monthNames[_ctx.currentMonth]) + " " + _toDisplayString(_ctx.currentYear), 1),
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.nextMonth && _ctx.nextMonth(...args))),
            class: "p-0 border-0 d-flex align-items-center justify-content-center rounded-circle transition"
          }, [...(_cache[5] || (_cache[5] = [
            _createElementVNode("i", { class: "material-symbols-outlined" }, "chevron_right", -1)
          ]))])
        ]),
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weekdays, (day) => {
            return (_openBlock(), _createElementBlock("div", { key: day }, _toDisplayString(day), 1))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.daysInMonth, (day, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: _normalizeClass(["card border-0 mx-auto text-black fw-medium border-radius", { 'current-day': _ctx.isToday(day) }])
            }, [
              (day !== null)
                ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(day), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_11, " "))
            ], 2))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bookings, (booking, index) => {
          return (_openBlock(), _createBlock(_component_RouterLink, {
            key: index,
            to: "/hotel/room-details",
            class: "mb-3 pb-3 border-bottom border-border-color child d-flex justify-content-between align-items-center flex-wrap gap-3 text-decoration-none"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("img", {
                    src: booking.image,
                    class: "rounded-1",
                    style: {"max-width":"80px"},
                    alt: "room"
                  }, null, 8, _hoisted_16)
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("h3", _hoisted_18, _toDisplayString(booking.roomName), 1),
                  _createElementVNode("span", _hoisted_19, " Booked by " + _toDisplayString(booking.guestName), 1),
                  _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.formatBookingDates(booking.checkIn, booking.checkOut)), 1)
                ])
              ]),
              _cache[6] || (_cache[6] = _createElementVNode("i", { class: "ri-arrow-right-line wh-30 d-flex d-lg-none d-xxl-flex justify-content-center align-items-center bg-border-color rounded-circle hover-bg" }, null, -1))
            ]),
            _: 2
          }, 1024))
        }), 128))
      ])
    ])
  ]))
}